import "core-js/modules/web.dom.iterable";
import { __awaiter, __extends, __generator, __spreadArrays } from "tslib";
import PurchaseServices from '@/modules/purchases/PurchaseServices';
import { BaseStockModel } from '@/core/standard/BaseStockModel';
import SerialService from '@/modules/utilities/SerialService';
import BarStockServices from "@/modules/stock/BarStockServices";
var purchase = {
  status: 'Required',
  extras: '',
  date: '',
  provider_uuid: '',
  stock_uuid: '',
  iva: '',
  total_price: 0,
  payment_type: null,
  products: []
};

var PurchaseModel =
/** @class */
function (_super) {
  __extends(PurchaseModel, _super);

  function PurchaseModel() {
    var _this = _super.call(this, purchase, PurchaseServices) || this;

    _this.modelName = 'Purchase';
    _this.request = 'JSON';
    return _this;
  }

  PurchaseModel.prototype.create = function (data, toast, toastConfig) {
    if (toast === void 0) {
      toast = null;
    }

    if (toastConfig === void 0) {
      toastConfig = {};
    }

    return __awaiter(this, void 0, void 0, function () {
      var purchaseProducts, serial, req, query, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            purchaseProducts = __spreadArrays(data.products);
            data.products = [];
            return [4
            /*yield*/
            , SerialService.getSerial(JSON.stringify({
              module: 'purchases'
            }))];

          case 1:
            serial = _a.sent().data;
            purchaseProducts.forEach(function (element) {
              element.extras = JSON.stringify(element.extras);
              element.quantity = +element.quantity.toFixed(2);
            });
            req = {
              status: 'Required',
              extras: JSON.stringify({
                serial: serial
              }),
              date: data.date,
              provider_uuid: data.provider_uuid,
              stock_uuid: data.stock_uuid,
              products_purchases: purchaseProducts
            };
            query = {
              query: req,
              method: 'POST'
            };
            return [4
            /*yield*/
            , this.service.insert(query)];

          case 2:
            response = _a.sent();

            if (response.complete) {
              return [2
              /*return*/
              , this.handleSuccess(response, 'Ok', null)];
            } else {
              this.handleError(response, toast, toastConfig);
              return [2
              /*return*/
              , false];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PurchaseModel.prototype.update = function (data, toast, toastConfig) {
    if (toast === void 0) {
      toast = null;
    }

    if (toastConfig === void 0) {
      toastConfig = {};
    }

    return __awaiter(this, void 0, void 0, function () {
      var req, query, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            req = {
              status: data.status,
              date: data.date,
              extras: JSON.stringify(data.extras),
              provider_uuid: data.provider_uuid,
              stock_uuid: data.stock_uuid,
              payment_type: data.payment_type
            };
            query = {
              query: req,
              method: 'PUT',
              id: data.uuid
            };
            return [4
            /*yield*/
            , this.service.update(query)];

          case 1:
            response = _a.sent();

            if (response.complete) {
              return [2
              /*return*/
              , this.handleSuccess(response, 'Ok', null)];
            } else {
              this.handleError(response, toast, toastConfig);
              return [2
              /*return*/
              , false];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PurchaseModel.prototype.getPurchaseFile = function (protocol) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , BarStockServices.downloadPurchaseFile({
              method: 'GET',
              query: protocol,
              headers: {
                Accept: '*/*'
              },
              responseType: 'blob'
            })];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  return PurchaseModel;
}(BaseStockModel);

export default PurchaseModel;